import React from 'react';
import {UserContext, WorkflowsContext} from '@web/hooks/context';
import {addPath, ServerTimestamp, updatePath} from '@web/lib/firestore.db';
import {Card, Divider} from 'antd';
import {notifyAndTrack} from '@web/components/notification';
import WorkflowServicesList from './WorkflowServicesList';
import CollectionFetch from '@web/ui/containers/CollectionFetch';
import omit from 'lodash/omit';

function AddAction () {
  const [userId] = React.useContext(UserContext);
  const wtx = React.useContext(WorkflowsContext);
  const [activeTabKey, setActiveTabKey] = React.useState("actions");

  const addAction = (action) => {
    addPath(["user", userId, "actions"].join("/"),
      {...action, date: ServerTimestamp()})
    .then((ref) =>
      updatePath(wtx.workflowPath, {
        steps: [
          ...wtx.workflow.steps || [],
          omit(action, ["contextTemplate", "date", "key", "modelPerformance", "objectID"]),
        ],
      }))
    .then(() => notifyAndTrack.success("Added"))
  };

  const tabList = [{
    key: "actions",
    tab: "Actions",
  },{
    key: "integrations",
    tab: "Apps",
  }];

  const tabsContent = {
    actions: <div>
      <Divider className="hidden" />
      <WorkflowServicesList
        list={wtx.stepHelpers}
        onSelect={addAction}
      />
    </div>,
    integrations: <div>
      <Divider className="hidden" />
      <CollectionFetch
        collectionId="app-store"
        component={WorkflowServicesList}
        onSelect={addAction}
      />
    </div>
  }

  return <div
    style={{width: "500px", maxWidth: "100%", overflow: "auto"}}
  >
    <div className="space space-col relative" style={{maxWidth: 500}}>
      <br/>
      <Card
        className="card-simple card-rounded card-no-header card-no-separator card-h-600 card-body-scroll"
        bordered={false}
        tabList={tabList}
        onTabChange={setActiveTabKey}
        activeTabKey={activeTabKey}
      >
        {tabsContent[activeTabKey]}
      </Card>
    </div>
  </div>
}

export default AddAction;
